import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'header',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      background: 'url(/assets/bg.png) center no-repeat',
      backgroundSize: 'cover',
      color: theme.palette.gradient.contrastText,
    },
  }),
  options
);

export default useStyles;
